import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { API_URL } from "../constants";
import { Loading } from "../components/Loading";
import { NoMatch } from "../components/NoMatch";
import './StaticPage.css';

export const StaticPage = () => {
  const params = useParams<{ country?: string; language: string; page: string }>();
  const [searchParams] = useSearchParams();

  // ISO alpha-3 country, from /:country/:language/:page or ?country=XXX. Empty means the
  // default page; the backend falls back to it when no country-specific page exists.
  const country = (params.country ?? searchParams.get('country') ?? '').trim().toUpperCase();

  const [loading, setLoading] = useState(true);
  const [pageItem, setPageItem] = useState({
    title: '',
    content: ''
  })

  useEffect(() => {
    const page = params.page ?? "";
    if (page) {
      setLoading(true);
      const language = params.language ?? 'en';
      const query = country ? `?country=${encodeURIComponent(country)}` : '';
      fetch(`${API_URL}/admin/agreement/public/${page}/${language}${query}`).then(async response => {
        const result = await response.json();
        setPageItem({
          title: result?.content?.title,
          content: result?.content?.content,
        })
      }).finally(() => {
        setLoading(false);
      })
    }
  }, [params.page, params.language, country]);

  if (loading) {
    return <Loading/>;
  }

  return (
    <section className="static-page">
      {pageItem?.title && <h1>{pageItem.title}</h1>}
      {pageItem?.content && <article dangerouslySetInnerHTML={{ __html: pageItem.content }}/>}

      {!pageItem?.title && !pageItem?.content && (
        <NoMatch/>
      )}
    </section>
  )
};
